import authService from './authService';

class TokenService {
  constructor() {
    this.token = null;
    this.rideId = null;
  }

  init = () => {
    let token = authService.getTokenFromUrl();
    let rideId = token && authService.getRideIdFromToken(token);
    if (!token || !rideId) {
      const searchParams = authService.getTokenAndIdForDevelopment();
      [token, rideId] = Object.values(searchParams);
    }
    if (token && rideId) {
      this.token = token;
      this.rideId = rideId;
      localStorage.setItem('delegation_token', this.token);
      return;
    }
    token = authService.getDelegationToken();
    rideId = authService.getRideIdFromUrl();
    if (token) this.token = token;
    if (rideId) this.rideId = rideId;

    this.timer = setInterval(() => {
      const localStorageToken = authService.getDelegationToken();
      if (localStorageToken) {
        this.token = localStorageToken;
        return;
      }
      this.token = null;
      this.rideId = null;
      clearTimeout(this.timer);
    }, 10000);
  };
  isToken = () => {
    if (!this.token) this.token = authService.getDelegationToken();
    return this.token && !authService.isTokenExpired(this.token);
  };
  isTokenForRider = () => {
    return this.isToken() && authService.isTokenRoleForRider(this.token);
  };
}

let tokenInst = null;

export const getToken = () => {
  if (!tokenInst) {
    tokenInst = new TokenService();
    try {
      tokenInst.init();
    } catch (e) {
      throw e;
    }
  }
  return tokenInst;
};
